import { env } from '@/config/env.ts';
import { api } from '@/api/api-client.config.ts';
import { useQuery } from '@tanstack/react-query';

type Tenant = {
  name: string;
  prefix: string;
};

export const getTenants = (): Promise<{ tenants: Tenant[] }> =>
  api.get(`${env.CLIENTS_API_BASE_URL}/clients/${env.CLIENT_CODE}/tenants`);

export const useGetTenants = () => {
  return useQuery({
    queryKey: ['getTenants'],
    queryFn: getTenants,
    select: (data) => data.tenants,
  });
};
